import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Utils } from './utils/utils';
import { Constants } from '../model/constants';
import { UserEsercitazione } from '../model/esercitazione/useresercitazione';

@Injectable({
  providedIn: 'root'
})
export class EsercitazioneService {

    constructor(private http: HttpClient) { }

    buildEsercitazione(moduleId: number): Observable<UserEsercitazione> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'exercise/build/' + moduleId;
        return this.http.get<UserEsercitazione>(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

    evaluateEsercitazione(esercitazione: UserEsercitazione): Observable<UserEsercitazione> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'exercise/evaluate';
        return this.http.post<UserEsercitazione>(
            Utils.setHost(Constants.API_ENDPOINT, url),
            JSON.stringify(esercitazione),
            {headers}
        );
    }

    loadEsercitazione(esercitazioneId: number): Observable<UserEsercitazione> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'exercise/' + esercitazioneId;
        return this.http.get<UserEsercitazione>(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

    loadArchiveEsercitazione(moduleId: number): Observable<Array<UserEsercitazione>> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'exercise/archive/' + moduleId;
        return this.http.get<Array<UserEsercitazione>>(
            Utils.setHost(Constants.API_ENDPOINT, url),
            {headers}
        );
    }

    downloadEsercitazioneDomandaImage(domandaId: number, fileName: string): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'image/domanda/' + fileName;
        return this.http.get<any>(
            Utils.setHost(Constants.MEDIA_ENDPOINT, url),
            {headers}
        );
    }

    downloadEsercitazioneDomandaImageJson(fileName: string): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'image/domandajson/' + fileName;
        return this.http.get<any>(
            Utils.setHost(Constants.MEDIA_ENDPOINT, url),
            {headers}
        );
    }
}
